import isEmpty from 'lodash/isEmpty'
import React, { useState } from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { ExtractAddressModal } from './ExtractAddressModal'
import type { Address } from '@ztechapps/common.contract'
import { useError } from '@ztechapps/common.hook'
import { useExtractOrderAddresses } from '@ztechapps/order.common'

export type AutoGenerateAddressButtonProps = {
  orderId: string
  onAddressSelected: (address: Address) => void
  disabled?: boolean
}

export const AutoGenerateAddressButton = ({
  orderId,
  onAddressSelected,
  disabled = false,
}: AutoGenerateAddressButtonProps) => {
  const [showModal, setShowModal] = useState(false)
  const { extractAddresses, loading, error, addresses } = useExtractOrderAddresses()
  const { onError } = useError()

  const handleClick = async () => {
    try {
      const extractedAddresses = await extractAddresses(orderId)
      if (isEmpty(extractedAddresses)) {
        // Show message if no addresses found
        onError(new Error('No addresses found in email communications.'))
      } else if (extractedAddresses.length === 1) {
        // Automatically select if only one address found
        onAddressSelected(extractedAddresses[0])
      } else {
        // Show modal for multiple addresses
        setShowModal(true)
      }
    } catch (err) {
      onError(err)
    }
  }

  const handleSelect = (address: Address) => {
    onAddressSelected(address)
    setShowModal(false)
  }

  const handleCancel = () => {
    setShowModal(false)
  }

  return (
    <>
      <BusyButton
        icon="wand-magic-sparkles"
        text=""
        onClick={handleClick}
        isBusy={loading}
        disabled={disabled}
        title="Auto-generate address from email communications"
        busyText=" "
      />
      <ExtractAddressModal
        addresses={addresses ?? []}
        loading={loading}
        error={error}
        onSelect={handleSelect}
        onCancel={handleCancel}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  )
}
